import * as React from 'react'

import BillListView from '../components/BillListView'
import useEnableBottomNavigation from '../hooks/useEnableBottomNavigation'

export default function TabHomeScreen() {
  useEnableBottomNavigation()

  return <BillListView isArchive={false} />
}
